/**
 *
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
 const PencilIcon = () => {
    return <img src="/images/help/pencil.svg" alt="ペンシル" />;
  };
  
  export default PencilIcon;